import type { OAuthData } from '../../model/oauth/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { useOAuthStore } from '../../model/oauth/store'

export const useOAuthApi = async (): Promise<OAuthData | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const store = useOAuthStore()

  const url = useAdminRoutes('admin.oauth.data')

  store.setLoading(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.get<ApiResponse>(url)

    if (!data.success) {
      toast.error(data.message)
      return null
    }

    const oauthData: OAuthData | null = data.data || null

    if (oauthData) {
      store.setGoogle(oauthData.google)
      store.setZoho(oauthData.zoho)
    }

    return oauthData
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return null
  } finally {
    store.setLoading(false)
  }
}
